export const CSV_REWARDS = [
    {
      id: 'csv-1-redragon-k552-mechanical-gaming-keyboard',
      name: 'Redragon K552 Mechanical Gaming Keyboard',
      cost: 1850,
      description: 'High-durability, loud tactile feedback, compact TKL layout.',
      image: 'https://m.media-amazon.com/images/I/71FSIp+tDNL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-2-havit-kb487l-mechanical-keyboard',
      name: 'Havit KB487L Mechanical Keyboard',
      cost: 2250,
      description: 'Unique colorway, compact but retains numpad for homework.',
      image: 'https://m.media-amazon.com/images/I/71yGtauB-AL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-3-keychron-c2-pro-custom-keyboard',
      name: 'Keychron C2 Pro Custom Keyboard',
      cost: 2880,
      description: 'Hot-swappable switches, VIA programmable, Mac/Win compatible.',
      image: 'https://m.media-amazon.com/images/I/61nvukv0pVL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-4-ajazz-ak820-pro-75-wireless',
      name: 'Ajazz AK820 Pro 75% Wireless',
      cost: 2935,
      description: 'Gasket mount for sound, TFT screen for GIFs/Status.',
      image: 'https://m.media-amazon.com/images/I/61FXthbEb-L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-5-royal-kludge-rk-r65',
      name: 'Royal Kludge RK R65',
      cost: 3000,
      description: '65% layout, extremely compact, sound-dampening foam built-in.',
      image: 'https://m.media-amazon.com/images/I/61hOhuiqrTL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-6-steelseries-apex-3-rgb',
      name: 'SteelSeries Apex 3 RGB',
      cost: 2400,
      description: 'Water-resistant, quiet switches for shared living spaces.',
      image: 'https://m.media-amazon.com/images/I/61is2ZwnHEL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-7-logitech-k845-mechanical-illuminated',
      name: 'Logitech K845 Mechanical Illuminated',
      cost: 2700,
      description: 'Aluminum build, white backlighting for a cleaner, mature look.',
      image: 'https://m.media-amazon.com/images/I/611OJscHryL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-8-msi-vigor-gk50-elite',
      name: 'MSI Vigor GK50 Elite',
      cost: 2700,
      description: 'Low profile, box white switches for stability and speed.',
      image: 'https://m.media-amazon.com/images/I/611OJscHryL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-9-redragon-k668-rgb-gaming-keyboard',
      name: 'Redragon K668 RGB Gaming Keyboard',
      cost: 2250,
      description: 'Full spectrum lighting, macro programmable.',
      image: 'https://m.media-amazon.com/images/I/618A+B25MKL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-10-epomaker-galaxy100',
      name: 'Epomaker Galaxy100',
      cost: 4950,
      description: 'High-end build quality feel at mid-range price.',
      image: 'https://m.media-amazon.com/images/I/71N3TA7934L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-11-aula-f99-wireless-mechanical',
      name: 'Aula F99 Wireless Mechanical',
      cost: 3795,
      description: 'Long battery life, tri-mode connectivity.',
      image: 'https://m.media-amazon.com/images/I/61UNbXGq9LL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-12-keychron-v6-wired-custom',
      name: 'Keychron V6 Wired Custom',
      cost: 4500,
      description: 'Full size 100% layout, QMK/VIA support.',
      image: 'https://m.media-amazon.com/images/I/61ZcYTxtgaL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-13-corsair-k70-rgb-tkl',
      name: 'Corsair K70 RGB TKL',
      cost: 5000,
      description: 'Tournament switch, durable aluminum frame.',
      image: 'https://m.media-amazon.com/images/I/61Lx7dhCuRL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-14-steelseries-apex-pro-tkl',
      name: 'SteelSeries Apex Pro TKL',
      cost: 2400,
      description: 'Adjustable actuation switches, OLED smart display.',
      image: 'https://m.media-amazon.com/images/I/61is2ZwnHEL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-15-glorious-gaming-model-o-mouse',
      name: 'Glorious Gaming Model O Mouse',
      cost: 2500,
      description: 'Honeycomb design for speed, highly popular.',
      image: 'https://m.media-amazon.com/images/I/71yoHF9iUYL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-16-logitech-g203-wired-gaming-mouse',
      name: 'Logitech G203 Wired Gaming Mouse',
      cost: 1000,
      description: 'Reliable sensor, classic shape, RGB Sync.',
      image: 'https://m.media-amazon.com/images/I/51nco3+NKLL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-17-corsair-harpoon-rgb-wireless-mouse',
      name: 'Corsair HARPOON RGB Wireless Mouse',
      cost: 2500,
      description: 'Freedom from cables at an entry-level price.',
      image: 'https://m.media-amazon.com/images/I/517wS6ktQyL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-18-razer-deathadder-v4-pro',
      name: 'Razer DeathAdder V4 Pro',
      cost: 8500,
      description: 'Ultra-lightweight, ergonomic, esports standard.',
      image: 'https://m.media-amazon.com/images/I/71j6PDIwegL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-19-alienware-aw610m-wireless-mouse',
      name: 'Alienware AW610M Wireless Mouse',
      cost: 4000,
      description: 'Distinctive design, long battery life.',
      image: 'https://m.media-amazon.com/images/I/71EdlWRFVnL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-20-logitech-lift-vertical-ergonomic-mouse',
      name: 'Logitech Lift Vertical Ergonomic Mouse',
      cost: 2580,
      description: 'Prevents RSI, ideal for heavy study/computer use.',
      image: 'https://m.media-amazon.com/images/I/61OkuiCWbDL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-21-gamesir-nova-lite-controller',
      name: 'GameSir Nova Lite Controller',
      cost: 1350,
      description: 'Affordable controller for Switch, PC, and Mobile.',
      image: 'https://m.media-amazon.com/images/I/61yHqDf0SqL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-22-xbox-core-wireless-controller',
      name: 'Xbox Core Wireless Controller',
      cost: 2750,
      description: 'The default controller for PC and Xbox gaming.',
      image: 'https://m.media-amazon.com/images/I/615-Ww2D6tL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-23-8bitdo-ultimate-controller',
      name: '8Bitdo Ultimate Controller',
      cost: 2750,
      description: 'Hall effect joysticks (no drift), charging dock included.',
      image: 'https://m.media-amazon.com/images/I/615-Ww2D6tL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-24-razer-kiyo-streaming-webcam',
      name: 'Razer Kiyo Streaming Webcam',
      cost: 5500,
      description: 'Built-in ring light for better video quality.',
      image: 'https://m.media-amazon.com/images/I/61dQJkzRopL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-25-elgato-stream-deck-mini',
      name: 'Elgato Stream Deck Mini',
      cost: 2900,
      description: '6 customizable LCD keys for controlling apps/streams.',
      image: 'https://m.media-amazon.com/images/I/61w+a4IDpsL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-26-blue-yeti-usb-microphone',
      name: 'Blue Yeti USB Microphone',
      cost: 5500,
      description: 'The gold standard for USB voice recording.',
      image: 'https://m.media-amazon.com/images/I/61dQJkzRopL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-27-hyperx-quadcast-s-microphone',
      name: 'HyperX QuadCast S Microphone',
      cost: 5500,
      description: 'RGB lighting microphone, highly visual for streams.',
      image: 'https://m.media-amazon.com/images/I/61dQJkzRopL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-28-steelseries-qck-gaming-mousepad',
      name: 'SteelSeries QcK Gaming Mousepad',
      cost: 1750,
      description: 'Essential surface for mouse accuracy.',
      image: 'https://m.media-amazon.com/images/I/31AROTdFEzL._AC_SL1050_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-29-razer-viper-v3-pro',
      name: 'Razer Viper V3 Pro',
      cost: 5750,
      description: 'High performance symmetrical gaming mouse.',
      image: 'https://m.media-amazon.com/images/I/619xpFKAXPL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-30-alienware-pro-wireless-gaming-mouse',
      name: 'Alienware Pro Wireless Gaming Mouse',
      cost: 6000,
      description: 'High DPI sensor, sleek white aesthetic.',
      image: 'https://m.media-amazon.com/images/I/510anYrOBhL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-31-hyperx-cloud-alpha-headset',
      name: 'HyperX Cloud Alpha Headset',
      cost: 3350,
      description: 'Aluminum frame, memory foam, detachable cable.',
      image: 'https://m.media-amazon.com/images/I/71++S+DNJ+L._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-32-razer-kraken-x-headset',
      name: 'Razer Kraken X Headset',
      cost: 1585,
      description: 'Lightweight, 7.1 surround sound capable.',
      image: 'https://m.media-amazon.com/images/I/41JtyPmutKL._AC_SL1000_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-33-astro-a50-x-lightspeed',
      name: 'ASTRO A50 X LIGHTSPEED',
      cost: 20000,
      description: 'Top-tier wireless audio, base station included.',
      image: 'https://m.media-amazon.com/images/I/61RnU+DsObL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-34-turtle-beach-stealth-600-gen-2',
      name: 'Turtle Beach Stealth 600 Gen 2',
      cost: 4700,
      description: 'Wireless specifically optimized for Xbox/PS5.',
      image: 'https://m.media-amazon.com/images/I/71boNMcgIOL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-35-jlab-go-air-pop-earbuds',
      name: 'JLab Go Air Pop Earbuds',
      cost: 1245,
      description: 'Compact, built-in charging cable, highly portable.',
      image: 'https://m.media-amazon.com/images/I/71iXX+yjm6L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-36-apple-airpods-pro-2nd-gen',
      name: 'Apple AirPods Pro (2nd Gen)',
      cost: 7700,
      description: 'The standard for iPhone users, active noise cancelling.',
      image: 'https://m.media-amazon.com/images/I/61SUj2aKoEL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-37-beats-studio-pro-headphones',
      name: 'Beats Studio Pro Headphones',
      cost: 12500,
      description: 'Over-ear noise cancelling with strong brand recognition.',
      image: 'https://m.media-amazon.com/images/I/61u-OaDSfQL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-38-sony-zv-1f-vlog-camera',
      name: 'Sony ZV-1F Vlog Camera',
      cost: 29900,
      description: 'High-end vlogging camera for aspiring YouTubers.',
      image: 'https://m.media-amazon.com/images/I/716gp4ChszL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-39-jbl-clip-4-portable-speaker',
      name: 'JBL Clip 4 Portable Speaker',
      cost: 3250,
      description: 'Durable, clip-on speaker for outdoor hangs/backpacks.',
      image: 'https://m.media-amazon.com/images/I/71+vyoFKtiL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-40-jbl-go-4-portable-speaker',
      name: 'JBL Go 4 Portable Speaker',
      cost: 2500,
      description: 'Tiny, waterproof speaker for shower/beach.',
      image: 'https://m.media-amazon.com/images/I/71kzInVwzgL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-41-lego-ideas-pixar-luxo-jr',
      name: 'LEGO Ideas Pixar Luxo Jr.',
      cost: 3155,
      description: 'Iconic lamp character, interactive balance mechanism.',
      image: 'https://m.media-amazon.com/images/I/71FXaMjDwDL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-42-lego-icons-orchid',
      name: 'LEGO Icons Orchid',
      cost: 2000,
      description: 'Maintenance-free botanical display, aesthetic appeal.',
      image: 'https://m.media-amazon.com/images/I/71iY-AO2D1L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-43-lego-super-mario-game-boy',
      name: 'LEGO Super Mario Game Boy',
      cost: 2800,
      description: 'Brick-built replica of classic handheld console.',
      image: 'https://m.media-amazon.com/images/I/71AV0wHyDUL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-44-lego-wicked-emerald-city-art',
      name: 'LEGO Wicked Emerald City Art',
      cost: 2750,
      description: '3D wall art from the Wicked movie/musical.',
      image: 'https://m.media-amazon.com/images/I/81fezZ6Rs8L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-45-lego-star-wars-death-star',
      name: 'LEGO Star Wars Death Star',
      cost: 50000,
      description: 'The ultimate collector\'s item, massive piece count.',
      image: 'https://m.media-amazon.com/images/I/818gjH7+PLL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-46-lego-architecture-trevi-fountain',
      name: 'LEGO Architecture Trevi Fountain',
      cost: 4495,
      description: 'Sophisticated build for geography/history buffs.',
      image: 'https://m.media-amazon.com/images/I/812Z87YUb9L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-47-lego-harry-potter-diagon-alley',
      name: 'LEGO Harry Potter Diagon Alley',
      cost: 10000,
      description: 'Microscale build of the wizarding shopping district.',
      image: 'https://m.media-amazon.com/images/I/818DfgocYKL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-48-lego-art-love-sculpture',
      name: 'LEGO Art LOVE Sculpture',
      cost: 3200,
      description: 'Recreation of the Robert Indiana sculpture.',
      image: 'https://m.media-amazon.com/images/I/71p8Y5dPQNL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-49-lego-jurassic-world-t-rex',
      name: 'LEGO Jurassic World T-Rex',
      cost: 12500,
      description: 'Museum-style skeleton display piece.',
      image: 'https://m.media-amazon.com/images/I/81XOohmwllL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-50-lego-duplo-bluey-s-house',
      name: 'LEGO DUPLO Bluey\'s House',
      cost: 3500,
      description: 'For the youngest users (2nd grade/siblings).',
      image: 'https://m.media-amazon.com/images/I/81KhtxLxX7L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-51-lego-creator-3in1-panda',
      name: 'LEGO Creator 3in1 Panda',
      cost: 1685,
      description: 'Rebuildable into panda, penguin, or orca.',
      image: 'https://m.media-amazon.com/images/I/81aUADdrrzL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-52-lego-disney-angel-lilo-stitch',
      name: 'LEGO Disney Angel (Lilo/Stitch)',
      cost: 2600,
      description: 'Buildable figure of Stitch\'s counterpart.',
      image: 'https://m.media-amazon.com/images/I/714aGFIiUCL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-53-lego-icons-neuschwanstein',
      name: 'LEGO Icons Neuschwanstein',
      cost: 3000,
      description: 'Complex castle build for advanced builders.',
      image: 'https://m.media-amazon.com/images/I/81Dv8VQkBOL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-54-lego-ideas-polaroid-camera',
      name: 'LEGO Ideas Polaroid Camera',
      cost: 4000,
      description: 'Realistic brick replica of SX-70 camera.',
      image: 'https://m.media-amazon.com/images/I/71xE5N4pd-L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-55-lego-technic-ford-mustang',
      name: 'LEGO Technic Ford Mustang',
      cost: 1200,
      description: 'Pull-back motor, durable for play.',
      image: 'https://m.media-amazon.com/images/I/81GXj4TGjQL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-56-lego-harry-potter-the-burrow',
      name: 'LEGO Harry Potter The Burrow',
      cost: 10000,
      description: 'Weasley house with unique angles/minifigs.',
      image: 'https://m.media-amazon.com/images/I/818DfgocYKL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-58-lego-the-burrow',
      name: 'LEGO The Burrow',
      cost: 13000,
      description: 'Massive, multi-level bank with dragon.',
      image: 'https://m.media-amazon.com/images/I/81BuGoqMKYL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-59-lego-icons-toothless-dragon',
      name: 'LEGO Icons Toothless Dragon',
      cost: 3500,
      description: 'Detailed Night Fury from How to Train Your Dragon.',
      image: 'https://m.media-amazon.com/images/I/71dxOe6xeaL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-60-lego-rivendell',
      name: 'LEGO Rivendell',
      cost: 25000,
      description: 'Massive LOTR set, highly detailed.',
      image: 'https://m.media-amazon.com/images/I/91Un4M87n2L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-61-ranch-tenor-ukulele-kit',
      name: 'Ranch Tenor Ukulele Kit',
      cost: 4150,
      description: 'Low barrier to entry, includes tuner/case.',
      image: 'https://m.media-amazon.com/images/I/81RwNlph1aL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-62-alesis-recital-88-key-piano',
      name: 'Alesis Recital 88-Key Piano',
      cost: 11450,
      description: 'Semi-weighted keys, educational software included.',
      image: 'https://m.media-amazon.com/images/I/71L-EMPSD5L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-63-yamaha-gigmaker-guitar-pack',
      name: 'Yamaha GigMaker Guitar Pack',
      cost: 12000,
      description: 'Acoustic starter pack from a trusted brand.',
      image: 'https://m.media-amazon.com/images/I/61sdBeqq2QL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-64-fender-squier-strat-pack',
      name: 'Fender Squier Strat Pack',
      cost: 14200,
      description: 'Electric guitar with amp, complete setup.',
      image: 'https://m.media-amazon.com/images/I/81hXIv1nZrL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-65-vangoa-5-string-banjo-kit',
      name: 'Vangoa 5-String Banjo Kit',
      cost: 8800,
      description: 'Niche instrument for unique musical interest.',
      image: 'https://m.media-amazon.com/images/I/71IgLyYl8rL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-66-sculpd-pottery-starter-kit',
      name: 'Sculpd Pottery Starter Kit',
      cost: 3250,
      description: 'Air-dry clay for sculpting at home without a kiln.',
      image: 'https://m.media-amazon.com/images/I/71+kDxQ7BnL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-67-3d-printing-pen-refills',
      name: '3D Printing Pen & Refills',
      cost: 1750,
      description: 'Draw 3D objects in mid-air, STEM creativity.',
      image: 'https://m.media-amazon.com/images/I/81+4z0Ki+xL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-68-national-geographic-science-magic',
      name: 'National Geographic Science Magic',
      cost: 1500,
      description: 'Chemistry experiments tailored for younger kids.',
      image: 'https://m.media-amazon.com/images/I/81ZUvHszgOL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-69-smartivity-music-machine',
      name: 'Smartivity Music Machine',
      cost: 4000,
      description: 'Build-it-yourself mechanical music box.',
      image: 'https://m.media-amazon.com/images/I/71-isfuZlrL._AC_SL1395_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-70-prismacolor-premier-pencils',
      name: 'Prismacolor Premier Pencils',
      cost: 3750,
      description: 'Professional grade colored pencils.',
      image: 'https://m.media-amazon.com/images/I/91zesHQEAAL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-71-82-piece-deluxe-art-set',
      name: '82-Piece Deluxe Art Set',
      cost: 2000,
      description: 'Case with paints, pastels, and pencils.',
      image: 'https://m.media-amazon.com/images/I/81hXPzq+YOL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-72-pink-picasso-paint-by-number',
      name: 'Pink Picasso Paint by Number',
      cost: 2400,
      description: 'Guided painting for stress relief.',
      image: 'https://m.media-amazon.com/images/I/61I33Wrex4L._AC_SL1080_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-73-casio-ct-s300-keyboard',
      name: 'Casio CT-S300 Keyboard',
      cost: 12000,
      description: '61 keys, touch responsive, portable.',
      image: 'https://m.media-amazon.com/images/I/81Xit+741VL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-74-adm-acoustic-mandolin-kit',
      name: 'ADM Acoustic Mandolin Kit',
      cost: 6500,
      description: 'Complete starter set for mandolin.',
      image: 'https://m.media-amazon.com/images/I/61oUBlGv5DL._AC_SL1499_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-75-epiphone-les-paul-player-pack',
      name: 'Epiphone Les Paul Player Pack',
      cost: 14450,
      description: 'Classic guitar shape with necessary amp.',
      image: 'https://m.media-amazon.com/images/I/81vZGUE6cOL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-76-owala-freesip-water-bottle-24oz',
      name: 'Owala FreeSip Water Bottle (24oz)',
      cost: 2000,
      description: 'The current status bottle, unique straw/spout.',
      image: 'https://m.media-amazon.com/images/I/51C2DONw-TL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-77-owala-freesip-32oz',
      name: 'Owala FreeSip (32oz)',
      cost: 1750,
      description: 'Larger capacity for sports/long days.',
      image: 'https://m.media-amazon.com/images/I/31Q5zKJ6J2L._AC_SL1000_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-78-s-well-stainless-steel-bottle',
      name: 'S\'well Stainless Steel Bottle',
      cost: 1750,
      description: 'Triple-layered insulation, condensation free.',
      image: 'https://m.media-amazon.com/images/I/51Lc4cZru5L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-79-thermos-funtainer-12oz',
      name: 'Thermos Funtainer (12oz)',
      cost: 950,
      description: 'Durable, straw lid, character designs available.',
      image: 'https://m.media-amazon.com/images/I/51Q+n-k0B8L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-80-iron-flask-sports-bottle',
      name: 'Iron Flask Sports Bottle',
      cost: 1000,
      description: 'Comes with 3 different lids, high utility.',
      image: 'https://m.media-amazon.com/images/I/51TAC0MJw9L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-81-stanley-quencher-h2-0',
      name: 'Stanley Quencher H2.0',
      cost: 2000,
      description: 'The viral tumbler, fits in car cup holders.',
      image: 'https://m.media-amazon.com/images/I/51eyeg7R2gL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-82-packit-freezable-lunch-box',
      name: 'PackIt Freezable Lunch Box',
      cost: 800,
      description: 'Built-in cooling gel, no ice packs needed.',
      image: 'https://m.media-amazon.com/images/I/81KDXaTZxFL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-83-bentgo-kids-prints-lunch-box',
      name: 'Bentgo Kids Prints Lunch Box',
      cost: 1500,
      description: 'Leak-proof bento style, durable drop-proof edges.',
      image: 'https://m.media-amazon.com/images/I/81GkPhNVhHL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-84-omiebox-insulated-bento-box',
      name: 'OmieBox Insulated Bento Box',
      cost: 2500,
      description: 'Thermos insert for hot food, separate cold zones.',
      image: 'https://m.media-amazon.com/images/I/61Eri1l0oeL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-85-simple-modern-kids-lunch-bag',
      name: 'Simple Modern Kids Lunch Bag',
      cost: 500,
      description: 'Matches their water bottles, insulated.',
      image: 'https://m.media-amazon.com/images/I/91OGmCk2DTL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-86-jansport-laptop-backpack',
      name: 'JanSport Laptop Backpack',
      cost: 2750,
      description: 'The industry standard for durability and warranty.',
      image: 'https://m.media-amazon.com/images/I/61raIxHuA7L._AC_SL1200_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-87-hawlander-little-kids-backpack',
      name: 'HawLander Little Kids Backpack',
      cost: 1050,
      description: 'Sized specifically for 3-6 year olds.',
      image: 'https://m.media-amazon.com/images/I/71aL4aNXq7L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-88-rockland-rolling-backpack',
      name: 'Rockland Rolling Backpack',
      cost: 1755,
      description: 'For students carrying heavy textbooks.',
      image: 'https://m.media-amazon.com/images/I/61yHtBxmG9L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-89-fjallraven-kanken-backpack',
      name: 'Fjallraven Kanken Backpack',
      cost: 4500,
      description: 'Distinctive square design, highly fashionable.',
      image: 'https://m.media-amazon.com/images/I/51rjGIkIISL._AC_SL1020_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-90-wanderfull-hydrobag',
      name: 'WanderFull HydroBag',
      cost: 3700,
      description: 'Dedicated bag for carrying expensive water bottles.',
      image: 'https://m.media-amazon.com/images/I/510wvVjh2+L._AC_SL1000_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-91-daybetter-led-strip-lights',
      name: 'Daybetter LED Strip Lights',
      cost: 1000,
      description: 'Essential for the "TikTok bedroom" look.',
      image: 'https://m.media-amazon.com/images/I/71ViPcitKHL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-92-galaxy-moon-lamp',
      name: 'Galaxy Moon Lamp',
      cost: 1200,
      description: 'Color changing night light/decor.',
      image: 'https://m.media-amazon.com/images/I/81XiLITH3IL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-93-hanging-neon-lights',
      name: 'Hanging Neon Lights',
      cost: 600,
      description: 'Various shapes (clouds, lightning) for walls.',
      image: 'https://m.media-amazon.com/images/I/71EyFUZQJoL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-94-burrito-tortilla-blanket',
      name: 'Burrito Tortilla Blanket',
      cost: 850,
      description: 'Viral novelty blanket, realistic print.',
      image: 'https://m.media-amazon.com/images/I/81LV23iu43L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-95-bedsure-strawberry-blanket',
      name: 'Bedsure Strawberry Blanket',
      cost: 1000,
      description: 'Cute aesthetic, plush throw.',
      image: 'https://m.media-amazon.com/images/I/81OltHLeB8L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-96-homecor-macrame-photo-display',
      name: 'Homecor Macrame Photo Display',
      cost: 1100,
      description: 'Display photos of friends/family on wall.',
      image: 'https://m.media-amazon.com/images/I/81TUeZbRMsL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-97-candle-warmer-lamp',
      name: 'Candle Warmer Lamp',
      cost: 1190,
      description: 'Safer alternative to burning candles in bedrooms.',
      image: 'https://m.media-amazon.com/images/I/71zstznPjvL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-98-xgimi-vibe-one-mini-projector',
      name: 'XGIMI Vibe One Mini Projector',
      cost: 9950,
      description: 'Turn bedroom wall into a movie screen.',
      image: 'https://m.media-amazon.com/images/I/514UppHo17L._AC_SL1280_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-99-philips-hue-lightstrip-base',
      name: 'Philips Hue Lightstrip Base',
      cost: 2800,
      description: 'Premium lighting synced to phone/gaming.',
      image: 'https://m.media-amazon.com/images/I/61ckdT7kfzL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-100-flower-floor-cushion',
      name: 'Flower Floor Cushion',
      cost: 740,
      description: 'Aesthetic floor seating for reading/hanging out.',
      image: 'https://m.media-amazon.com/images/I/61dqKLFQf+L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-101-plush-round-rug',
      name: 'Plush Round Rug',
      cost: 1125,
      description: 'Softens the room, adds texture.',
      image: 'https://m.media-amazon.com/images/I/81Icd+wbmvL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-103-reacher-sunrise-alarm-clock',
      name: 'Reacher Sunrise Alarm Clock',
      cost: 1850,
      description: 'Gentle wake up with light simulation.',
      image: 'https://m.media-amazon.com/images/I/41cwC8EdMlL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-104-igloo-mini-fridge',
      name: 'Igloo Mini Fridge',
      cost: 8865,
      description: 'Cold drinks in the bedroom.',
      image: 'https://m.media-amazon.com/images/I/61iovK065sL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-105-home-it-bed-risers',
      name: 'Home-It Bed Risers',
      cost: 1000,
      description: 'Creates space under bed for bins.',
      image: 'https://m.media-amazon.com/images/I/61bZBNwqM+L._AC_SL1024_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-106-revlon-one-step-volumizer',
      name: 'Revlon One-Step Volumizer',
      cost: 2820,
      description: 'The standard for easy home blowouts.',
      image: 'https://m.media-amazon.com/images/I/611IKm-sn2L._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-107-sol-de-janeiro-jet-set',
      name: 'Sol de Janeiro Jet Set',
      cost: 1700,
      description: 'Highly trending vanilla/pistachio scent.',
      image: 'https://m.media-amazon.com/images/I/81Ldb8+PkcL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-108-laneige-lip-sleeping-mask',
      name: 'Laneige Lip Sleeping Mask',
      cost: 1100,
      description: 'Viral luxury lip balm.',
      image: 'https://m.media-amazon.com/images/I/51O7t9I+EzL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-109-chillhouse-chill-tips-nails',
      name: 'Chillhouse Chill Tips Nails',
      cost: 800,
      description: 'High-quality press-on nails with art designs.',
      image: 'https://m.media-amazon.com/images/I/71PIkxOxgSL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-110-fancii-led-vanity-mirror',
      name: 'Fancii LED Vanity Mirror',
      cost: 2350,
      description: 'Professional lighting for application.',
      image: 'https://m.media-amazon.com/images/I/41OLLP4oooL._AC_SL1080_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-111-philips-norelco-multigroom',
      name: 'Philips Norelco Multigroom',
      cost: 2000,
      description: 'All-in-one trimmer for teen boys.',
      image: 'https://m.media-amazon.com/images/I/81FIedn+trL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-112-not-your-mother-s-sea-salt',
      name: 'Not Your Mother\'s Sea Salt',
      cost: 1190,
      description: 'Essential for the "fluffy hair" trend.',
      image: 'https://m.media-amazon.com/images/I/71rQq05apyL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-113-the-crme-shop-hello-kitty-band',
      name: 'The Creme Shop Hello Kitty Band',
      cost: 450,
      description: 'Keeps hair back during face washing.',
      image: 'https://m.media-amazon.com/images/I/51kP86b7dvL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-114-phlur-vanilla-skin-body-mist',
      name: 'PHLUR Vanilla Skin Body Mist',
      cost: 1900,
      description: 'Sophisticated but age-appropriate fragrance.',
      image: 'https://m.media-amazon.com/images/I/519JndlPAQL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-115-canitoron-makeup-organizer',
      name: 'Canitoron Makeup Organizer',
      cost: 2750,
      description: 'Storage for skincare/makeup clutter.',
      image: 'https://m.media-amazon.com/images/I/71j5VwlwZWL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-116-funko-pop-chainsaw-man',
      name: 'Funko Pop: Chainsaw Man',
      cost: 1500,
      description: 'Chainsaw Man fits the Anime profile: Highly popular modern anime protagonist.',
      image: 'https://m.media-amazon.com/images/I/61PwG7NlDvL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-117-funko-pop-spider-man',
      name: 'Funko Pop: Spider-Man',
      cost: 745,
      description: 'Spider-Man fits the Marvel profile: Classic hero, universally liked.',
      image: 'https://m.media-amazon.com/images/I/61BzIj0BRgL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-118-funko-pop-demon-slayer-daki',
      name: 'Funko Pop: Demon Slayer Daki',
      cost: 1055,
      description: 'Demon Slayer Daki fits the Anime profile: Villain from popular arc.',
      image: 'https://m.media-amazon.com/images/I/71X0yrAIoPL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-119-funko-pop-toothless',
      name: 'Funko Pop: Toothless',
      cost: 1000,
      description: 'Toothless fits the Animation profile: Beloved dragon character.',
      image: 'https://m.media-amazon.com/images/I/71qyjbcuCXL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-120-funko-pop-darth-vader',
      name: 'Funko Pop: Darth Vader',
      cost: 600,
      description: 'Darth Vader fits the Classic profile: Iconic Star Wars villain.',
      image: 'https://m.media-amazon.com/images/I/61s6vlqz-LL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-121-funko-pop-spongebob-doodlebob',
      name: 'Funko Pop: SpongeBob Doodlebob',
      cost: 750,
      description: 'SpongeBob Doodlebob fits the Meme profile: Funny/Nostalgic deep cut character.',
      image: 'https://m.media-amazon.com/images/I/71WkP7Pz7mL._AC_SL1300_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-122-funko-pop-one-piece-luffy',
      name: 'Funko Pop: One Piece Luffy',
      cost: 750,
      description: 'One Piece Luffy fits the Anime profile: Protagonist of the massive One Piece series.',
      image: 'https://m.media-amazon.com/images/I/81HnDIqQf4L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-123-taco-cat-goat-cheese-pizza',
      name: 'Taco Cat Goat Cheese Pizza',
      cost: 750,
      description: 'Fast-paced, slap-the-card game.',
      image: 'https://m.media-amazon.com/images/I/61S09uP0gLL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-124-exploding-kittens-card-game',
      name: 'Exploding Kittens Card Game',
      cost: 1250,
      description: 'Russian roulette with kittens.',
      image: 'https://m.media-amazon.com/images/I/81foKuTvMML._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-125-uno-deluxe-card-game',
      name: 'Uno Deluxe Card Game',
      cost: 750,
      description: 'Essential card game for groups.',
      image: 'https://m.media-amazon.com/images/I/71PWDi01-+L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-126-codenames-board-game',
      name: 'Codenames Board Game',
      cost: 1250,
      description: 'Word association team game.',
      image: 'https://m.media-amazon.com/images/I/81-ZhxEhSWL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-127-ticket-to-ride-berlin',
      name: 'Ticket to Ride: Berlin',
      cost: 1250,
      description: 'Berlin fits the Strategy profile: Fast version of the classic train game.',
      image: 'https://m.media-amazon.com/images/I/91zZZuPwrlL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-128-the-uzzle-3-0-puzzle-game',
      name: 'The Uzzle 3.0 Puzzle Game',
      cost: 2500,
      description: 'Fast-paced pattern matching puzzle.',
      image: 'https://m.media-amazon.com/images/I/71SaknlttBL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-129-kan-jam-disc-game',
      name: 'Kan Jam Disc Game',
      cost: 2000,
      description: 'Frisbee accuracy game.',
      image: 'https://m.media-amazon.com/images/I/7145pGDm9FL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-130-spikeball-game-set',
      name: 'Spikeball Game Set',
      cost: 8000,
      description: 'High energy 2v2 outdoor sport.',
      image: 'https://m.media-amazon.com/images/I/71n74j5mZIL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-131-crossnet-volleyball-net',
      name: 'Crossnet Volleyball Net',
      cost: 5000,
      description: '4-square meets volleyball.',
      image: 'https://m.media-amazon.com/images/I/81+LWRiXdGL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-132-throw-throw-burrito',
      name: 'Throw Throw Burrito',
      cost: 1000,
      description: 'Dodgeball meets card game.',
      image: 'https://m.media-amazon.com/images/I/71I+tO-hLcL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-133-spot-it-card-game',
      name: 'Spot It! Card Game',
      cost: 340,
      description: 'Speed pattern recognition.',
      image: 'https://m.media-amazon.com/images/I/71Pb5-Ug8uL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-134-monopoly-deal-card-game',
      name: 'Monopoly Deal Card Game',
      cost: 550,
      description: 'Monopoly without the 4 hour play time.',
      image: 'https://m.media-amazon.com/images/I/71F97tkQ-yL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-135-sushi-go',
      name: 'Sushi Go!',
      cost: 600,
      description: 'Pick and pass card game.',
      image: 'https://m.media-amazon.com/images/I/719CBtI0WSL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-136-apple-airtag-4-pack',
      name: 'Apple AirTag (4 Pack)',
      cost: 3250,
      description: 'Track backpacks, keys, wallets.',
      image: 'https://m.media-amazon.com/images/I/61bMNCeAUAL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-137-chipolo-one-point-tracker',
      name: 'Chipolo One Point Tracker',
      cost: 1450,
      description: 'Alternative to AirTag for Android users.',
      image: 'https://m.media-amazon.com/images/I/51cwlAMjuBL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-138-usb-c-magnetic-adapter',
      name: 'USB-C Magnetic Adapter',
      cost: 1400,
      description: 'Prevents laptop charging ports from snapping.',
      image: 'https://m.media-amazon.com/images/I/61lKg7N17HL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-140-anker-3-in-1-charging-stand',
      name: 'Anker 3-in-1 Charging Stand',
      cost: 4875,
      description: 'Charge phone, watch, and buds simultaneously.',
      image: 'https://m.media-amazon.com/images/I/71g-3rva1+L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-141-torras-minimag-power-bank',
      name: 'Torras MiniMag Power Bank',
      cost: 2375,
      description: 'Ultra-thin magsafe battery pack.',
      image: 'https://m.media-amazon.com/images/I/719Cpdbw8CL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-142-octobuddy-suction-mount',
      name: 'Octobuddy Suction Mount',
      cost: 750,
      description: 'Stick phone to mirrors/windows for TikToks.',
      image: 'https://m.media-amazon.com/images/I/61-kDa-TPoL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-143-popsockets-popgrip',
      name: 'PopSockets PopGrip',
      cost: 1500,
      description: 'Grip for larger phones.',
      image: 'https://m.media-amazon.com/images/I/51iWFM8x80L._AC_SL1199_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-144-esr-aura-magsafe-wallet',
      name: 'ESR Aura MagSafe Wallet',
      cost: 850,
      description: 'Wallet that attaches to phone with Find My.',
      image: 'https://m.media-amazon.com/images/I/81mCjsNEF+L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-145-fire-tv-stick-4k',
      name: 'Fire TV Stick 4K',
      cost: 1750,
      description: 'Streaming upgrade for older TVs.',
      image: 'https://m.media-amazon.com/images/I/61DlnQ8q-gL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-147-ear-wax-removal-camera',
      name: 'Ear Wax Removal Camera',
      cost: 2330,
      description: 'Gross but satisfying tech tool.',
      image: 'https://m.media-amazon.com/images/I/71ae00kjIyL._AC_SL1498_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-148-apple-airtag-secure-holder',
      name: 'Apple AirTag Secure Holder',
      cost: 940,
      description: 'Belkin keychain for AirTag.',
      image: 'https://m.media-amazon.com/images/I/61p2iivMSrL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-150-fitvii-fitness-tracker',
      name: 'FITVII Fitness Tracker',
      cost: 2500,
      description: 'Budget alternative to Fitbit/Apple Watch.',
      image: 'https://m.media-amazon.com/images/I/61dV494jBgL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-151-mead-spiral-notebooks-6pk',
      name: 'Mead Spiral Notebooks (6pk)',
      cost: 650,
      description: 'Essential supply, color coded.',
      image: 'https://m.media-amazon.com/images/I/81m6MpZHa7L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-152-pilot-frixion-erasable-pens',
      name: 'Pilot FriXion Erasable Pens',
      cost: 1500,
      description: 'Gel ink that erases cleanly.',
      image: 'https://m.media-amazon.com/images/I/91RJNVcp+IL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-153-amazon-basics-scissors-3pk',
      name: 'Amazon Basics Scissors (3pk)',
      cost: 305,
      description: 'Durable craft scissors.',
      image: 'https://m.media-amazon.com/images/I/51+yys+guCL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-154-four-candies-mechanical-pencils',
      name: 'Four Candies Mechanical Pencils',
      cost: 400,
      description: 'Pastel colors, high capacity lead.',
      image: 'https://m.media-amazon.com/images/I/71wyAuE3VUL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-155-crayola-washable-crayons',
      name: 'Crayola Washable Crayons',
      cost: 1000,
      description: 'Bulk pack for creative projects.',
      image: 'https://m.media-amazon.com/images/I/81ZF7DubIVL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-156-sooez-high-capacity-pencil-case',
      name: 'Sooez High Capacity Pencil Case',
      cost: 400,
      description: 'Holds 50+ pens, aesthetic design.',
      image: 'https://m.media-amazon.com/images/I/71hIhEriscL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-157-texas-instruments-ti-503-sv',
      name: 'Texas Instruments TI-503 SV',
      cost: 365,
      description: 'Simple pocket calculator.',
      image: 'https://m.media-amazon.com/images/I/71OgeC0-3ML._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-158-texas-instruments-ti-84-plus',
      name: 'Texas Instruments TI-84 Plus',
      cost: 5000,
      description: 'The gold standard graphing calculator.',
      image: 'https://m.media-amazon.com/images/I/71oJANqFo0L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-159-unionbasic-desk-organizer',
      name: 'UnionBasic Desk Organizer',
      cost: 500,
      description: 'Faux leather caddy for tidiness.',
      image: 'https://m.media-amazon.com/images/I/61RI8yb3QIL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-160-buyify-folding-lap-desk',
      name: 'Buyify Folding Lap Desk',
      cost: 2360,
      description: 'Work from bed/couch with device slot.',
      image: 'https://m.media-amazon.com/images/I/61rmvqPaY+L._AC_SL1437_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-161-rocketbook-core-notebook',
      name: 'Rocketbook Core Notebook',
      cost: 1500,
      description: 'Reusable notebook that uploads to cloud.',
      image: 'https://m.media-amazon.com/images/I/81RHqqjbYML._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-162-kadams-pomodoro-timer',
      name: 'Kadams Pomodoro Timer',
      cost: 850,
      description: 'Visual timer for study blocks.',
      image: 'https://m.media-amazon.com/images/I/71XaTbmOiJL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-163-keurig-k-mini-coffee-maker',
      name: 'Keurig K-Mini Coffee Maker',
      cost: 3000,
      description: 'Personal caffeine station.',
      image: 'https://m.media-amazon.com/images/I/613wb2ffuRL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-164-dirt-devil-versa-3-in-1-vac',
      name: 'Dirt Devil Versa 3-in-1 Vac',
      cost: 4500,
      description: 'Lightweight cleaning for small spaces.',
      image: 'https://m.media-amazon.com/images/I/51P7ZP+3RaL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-165-paper-mate-flair-felt-tip-pens',
      name: 'Paper Mate Flair Felt Tip Pens',
      cost: 510,
      description: 'Colorful pens for organizing notes.',
      image: 'https://m.media-amazon.com/images/I/81X1SjEnOyL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-166-gotrax-g4-electric-scooter',
      name: 'Gotrax G4 Electric Scooter',
      cost: 22500,
      description: '20mph speed, commuter friendly.',
      image: 'https://m.media-amazon.com/images/I/61AfXtPfSeL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-167-niu-k3-max-electric-scooter',
      name: 'Niu K3 Max Electric Scooter',
      cost: 18950,
      description: 'Best value commuter scooter.',
      image: 'https://m.media-amazon.com/images/I/61o01YQUd6L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-168-segway-ninebot-e2-plus',
      name: 'Segway Ninebot E2 Plus',
      cost: 16000,
      description: 'Reliable brand, city commuter.',
      image: 'https://m.media-amazon.com/images/I/61skMRN3QML._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-169-iscooter-ix4-off-road',
      name: 'iScooter iX4 Off-Road',
      cost: 25000,
      description: 'Off-road tires, high power.',
      image: 'https://m.media-amazon.com/images/I/71Sq3cejK4L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-170-jasion-js3-electric-scooter',
      name: 'Jasion JS3 Electric Scooter',
      cost: 14500,
      description: 'Seated scooter option.',
      image: 'https://m.media-amazon.com/images/I/713pfTRDFSL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-171-hurtle-folding-scooter',
      name: 'Hurtle Folding Scooter',
      cost: 3500,
      description: 'High incline handling.',
      image: 'https://m.media-amazon.com/images/I/71VC8f0OnVL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-172-inmotion-climber-scooter',
      name: 'Inmotion Climber Scooter',
      cost: 34950,
      description: 'Dual motors for hilly areas.',
      image: 'https://m.media-amazon.com/images/I/51Ph9kf8OFL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-173-apple-macbook-air-13-m3',
      name: 'Apple MacBook Air 13" (M3)',
      cost: 39950,
      description: 'Premium student laptop.',
      image: 'https://m.media-amazon.com/images/I/71cWZUr9SVL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-174-apple-ipad-pen-pro',
      name: 'Apple Pencil Pro',
      cost: 4750,
      description: 'Pen for art and media.',
      image: 'https://m.media-amazon.com/images/I/41iLLpfSWxL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-175-meta-quest-3',
      name: 'Meta Quest 3',
      cost: 24950,
      description: 'Cutting edge virtual reality.',
      image: 'https://m.media-amazon.com/images/I/61nkctF66PL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-176-sony-zv-1f-vlog-camera',
      name: 'Sony ZV-1F Vlog Camera',
      cost: 29900,
      description: 'Dedicated vlogging hardware.',
      image: 'https://m.media-amazon.com/images/I/716gp4ChszL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-177-kodak-pixpro-fz55',
      name: 'KODAK PIXPRO FZ55',
      cost: 8000,
      description: '"Vintage" digital aesthetic.',
      image: 'https://m.media-amazon.com/images/I/81swjZCbdiL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-178-fujifilm-instax-mini-12',
      name: 'Fujifilm Instax Mini 12',
      cost: 4640,
      description: 'Instant physical photos.',
      image: 'https://m.media-amazon.com/images/I/51iw5W-7i9L._AC_SL1200_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-179-polaroid-now-gen-2-camera',
      name: 'Polaroid Now Gen 2 Camera',
      cost: 5250,
      description: 'Classic instant film format.',
      image: 'https://m.media-amazon.com/images/I/713xak1KBeL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-180-beats-studio-pro',
      name: 'Beats Studio Pro',
      cost: 12500,
      description: 'Premium over-ear headphones.',
      image: 'https://m.media-amazon.com/images/I/51Xqu8JrqeL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-181-frito-lay-variety-pack',
      name: 'Frito-Lay Variety Pack',
      cost: 785,
      description: 'Bulk chips for sharing.',
      image: 'https://m.media-amazon.com/images/I/91R081RZiML._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-182-goldfish-crackers-bulk',
      name: 'Goldfish Crackers Bulk',
      cost: 955,
      description: 'Universal favorite.',
      image: 'https://m.media-amazon.com/images/I/81Ab6BLZ8oL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-183-welch-s-fruit-snacks',
      name: 'Welch\'s Fruit Snacks',
      cost: 820,
      description: 'Sweet treat.',
      image: 'https://m.media-amazon.com/images/I/81sWNT5CuEL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-184-kind-bars-variety-pack',
      name: 'KIND Bars Variety Pack',
      cost: 1250,
      description: 'Healthier option.',
      image: 'https://m.media-amazon.com/images/I/81cS4hNZZjL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-185-pringles-snack-stacks',
      name: 'Pringles Snack Stacks',
      cost: 1085,
      description: 'Portable chips.',
      image: 'https://m.media-amazon.com/images/I/81OGGo6D9iL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-186-oreo-cookies-family-size',
      name: 'Oreo Cookies Family Size',
      cost: 495,
      description: 'Classic cookie.',
      image: 'https://m.media-amazon.com/images/I/81MQenyXpbL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-187-mott-s-fruit-snacks',
      name: 'Mott\'s Fruit Snacks',
      cost: 400,
      description: 'Fruit flavored.',
      image: 'https://m.media-amazon.com/images/I/81tqpWe0+xL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-188-pirate-s-booty-popcorn',
      name: 'Pirate\'s Booty Popcorn',
      cost: 805,
      description: 'Light snack.',
      image: 'https://m.media-amazon.com/images/I/81WcYOyHm-L._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-189-quaker-chewy-granola-bars',
      name: 'Quaker Chewy Granola Bars',
      cost: 900,
      description: 'Breakfast/snack.',
      image: 'https://m.media-amazon.com/images/I/81vP7BTWOnL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-190-jack-link-s-beef-jerky',
      name: 'Jack Link\'s Beef Jerky',
      cost: 2040,
      description: 'Protein snack.',
      image: 'https://m.media-amazon.com/images/I/71zDAZ9rkGL._SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-191-fidget-spinning-pen',
      name: 'Fidget Spinning Pen',
      cost: 450,
      description: 'Pen + fidget toy combo.',
      image: 'https://m.media-amazon.com/images/I/616lcW2I2OL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-192-cleaning-gel-for-car-pc',
      name: 'Cleaning Gel for Car/PC',
      cost: 400,
      description: 'Slime for cleaning keyboards.',
      image: 'https://m.media-amazon.com/images/I/71YLxhnPUxL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-193-rechargeable-book-light',
      name: 'Rechargeable Book Light',
      cost: 450,
      description: 'Clip on light.',
      image: 'https://m.media-amazon.com/images/I/41YBQJM1-GL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-194-electric-candle-lighter',
      name: 'Electric Candle Lighter',
      cost: 650,
      description: 'USB rechargeable lighter.',
      image: 'https://m.media-amazon.com/images/I/61F-IcZIicL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-195-screen-magnifier-for-phone',
      name: 'Screen Magnifier for Phone',
      cost: 1730,
      description: 'Enlarges phone screen.',
      image: 'https://m.media-amazon.com/images/I/710WTRC9ZzL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-196-digital-kitchen-timer-cube',
      name: 'Digital Kitchen Timer Cube',
      cost: 2700,
      description: 'Flip to set timer.',
      image: 'https://m.media-amazon.com/images/I/710JmgsgnTL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-197-retractable-car-charger',
      name: 'Retractable Car Charger',
      cost: 1800,
      description: 'Tangle-free charging.',
      image: 'https://m.media-amazon.com/images/I/71WeDednX4L._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-198-laptop-stand-adjustable',
      name: 'Laptop Stand (Adjustable)',
      cost: 2000,
      description: 'Better posture for laptops.',
      image: 'https://m.media-amazon.com/images/I/81GFlMtYWcL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-199-straw-covers-stanley',
      name: 'Straw Covers (Stanley)',
      cost: 250,
      description: 'Cute toppers for straws.',
      image: 'https://m.media-amazon.com/images/I/5125L+lBHQL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
    {
      id: 'csv-200-satin-pillowcase',
      name: 'Satin Pillowcase',
      cost: 350,
      description: 'Better for hair/skin.',
      image: 'https://m.media-amazon.com/images/I/71lChEqublL._AC_SL1500_.jpg',
      bgColor: 'from-slate-800 to-slate-950',
    },
  ];